import {
  allActivity,
  propertyConditionMaping,
  filterChangeCondition,
  filterChangeSubCondition,
  filterConditionMaping,
  filterSubConditionMaping,
} from "@/constants/automation";
import { useAutomationCreate } from "@/store/automationCreate";

export const getPropertyConditions = (field) => {
  var fieldMap = propertyConditionMaping[field]
    ? propertyConditionMaping[field]
    : propertyConditionMaping["Text"];
  return fieldMap.map((id) => ({ id, label: filterChangeCondition[id] }));
};

export const getFilterConditions = (conditionId) => {
  var filterMap = filterConditionMaping[conditionId]
    ? filterConditionMaping[conditionId]
    : [];
  return filterMap.map((id) => ({ id, label: filterChangeCondition[id] }));
};
export const getFilterSubConditions = (conditionId, subId) => {
  var filterMap = filterSubConditionMaping[conditionId][subId]
    ? filterSubConditionMaping[conditionId][subId]
    : [];
  return filterMap.map((id) => ({ id, label: filterChangeSubCondition[id] }));
};

export const getAllActivity = () => {
  return Object.values(allActivity);
};

export const resetAction = () => {
  const store = useAutomationCreate();
  store.$patch((state) => {
    state.action = "";
    state.actionId = 0;
    state.branchType = 0;
  });
};

export const automationAllowedLimit = () => {
  const limit = parseInt(localStorage.getItem("automation_allowed_limit"));
  return limit;
};
